import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-common-details',
  templateUrl: './common-details.component.html',
  styleUrls: ['./common-details.component.scss']
})
export class CommonDetailsComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() isedit: boolean;
  @Input() displaycomname: string;
  @Input() commonlistObj: any;
  @Input() sellerId: number;
  commonObject: any = {
    project_name: null,
    sub_category_position: null
  };
  @Input() isInternalEditable: boolean;
  commonListObject: any = {
    formone: [],
    formtwo: [],
    questionset: []
  };
  commonmultiSelect: any = {};
  commonmultiSelectOptions: any = {};
  commonDisableObject: any = {};
  isEditable: boolean;
  displaycomponentName: string;
  @ViewChild('accordionExampleQuestion') accordionExampleQuestion: ElementRef;
  htmlstringvalue: string;
  isDisplayQuestionSet: boolean;
  subcategory_name: string;
  isInternalProject: boolean;
  othercategoryrow: any = {};
  currentSellerId: number;
  common_work_other: Array<any> = [{
    work_item_name: 'name',
    work_item_amount: '4535',
    work_item_description: 'asfdasfdsfd'
  }];
  constructor(private sellerService: SellerApiService) { }

  ngOnInit() {
    this.commonObject['work_other'] = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isDisplayQuestionSet = false;
    this.commonObject = this.data;
    this.commonListObject = this.commonlistObj;
    this.isEditable = this.isedit;
    this.subcategory_name = this.commonObject.service_category_name;
    this.displaycomponentName = this.displaycomname;
    this.isInternalProject = this.isInternalEditable;
    this.currentSellerId = this.sellerId;
    this.commonListObject.formtwo.map((item) => {
      if (item.type === 'multiselect') {
        this.commonmultiSelect[item.modal] = this.getMultiselectRow(this.commonObject[item.modal]);
      }
      if (item.type === 'dynamicworkrow') {
        if (item.value !== null) {
          this.commonObject[item.modal] = [];
        }
      }
      if (this.isInternalProject) {
        if (item.type === 'dropdown') {
          this.commonObject[item.modal] = 0;
        }
      }


    });

    this.commonListObject.formtwo.map((item) => {
      if (item.type === 'multiselect') {
        this.commonmultiSelectOptions[item.modal] = this.getMultiSelectValues(item.value);
      }
    });
  }


  getMultiselectRow(item: string) {
    const returnitem: Array<any> = [];
    if (typeof item === 'string') {
      const itemarray = item.split(',');
      itemarray.forEach(val => {
        returnitem.push({ name: val });
      });
    }
    return returnitem;
  }

  getDisplayMultiSelect(returnitem: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let value = returnitem.map(function (item) {
      return item['name'];
    });
    if (value.length === 0 || value === null) {
      return '';
    } else {
      return value;
    }
  }


  // Remove First Value From Dropdown
  getDropdownList(items: Array<any>, defaultvalue): Array<any> {
    items.map((item, index) => {
      if (item === defaultvalue) {
        items.splice(index, 1);
      }
    });
    return items;
  }

  // get MultiSelect Values
  getMultiSelectValues(items: Array<any>): Array<any> {
    const value = [];
    items.map((item) => {
      value.push({ name: item });
    });
    return value;
  }

  getValues(position, values) {
    if (this.commonObject[position] != null) {
      return values[Number(this.commonObject[position])];
    }
    return '';
  }

  // Common Object
  onchangeModal(value, propertyvalue, mainvariablevalue) {
    this.commonDisableObject[propertyvalue] = false;
    this.commonObject[mainvariablevalue] = false;
    Object.keys(this.commonObject).forEach(e => {
      if (e.indexOf(value) > -1) {
        if (this.commonObject[e]) {
          this.commonObject[mainvariablevalue] = true;
          this.commonDisableObject[propertyvalue] = true;
          return;
        }
      }
    });
  }

  generateYears() {
    const currentYear = new Date().getFullYear(), years = [];
    let startYear = 1970;

    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years;
  }

  getIsIdentifySelected(value, index) {
    this.isDisplayQuestionSet = value;
    return '';
  }

  // Add Other Category Row
  addOtherCategoryValue() {
    this.commonObject['work_other'].push({
      work_item_id: 0,
      work_item_name: '',
      work_item_amount: '',
      work_item_description: ''
    });
  }

  deleteOtherCategoryValue(index) {
    this.commonObject['work_other'].splice(index, 1);
  }

  // Get the Worker_Other Details
  getOtherCategoryValue() {
    if (this.currentSellerId != null) {
      this.sellerService.getOthercategoryWorkerItem(this.currentSellerId).pipe(finalize(() => {
      })).subscribe(response => {
       this.commonObject['work_other'] = response;
      }, err => {
        console.log(err);
      });
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/common/common-details/common-details.component.ts